<div class="form-data-container" id="crmWebToEntityForm">
    <p class="form-data-title">Contacto</p>
<div class="contact-cta"><h4>¡Hola y gracias por tu interés en Bitex!</h4><p>Compartinos tu teléfono de contacto contándonos tu inquietud o necesidad y nuestro equipo se pondrá en contacto contigo.</p><a href="mailto:hola@bitex.la" class="btn-blue">CONTÁCTANOS</a></div>
</div>

<!--iframe name='captchaFrame' style='display:none;'></iframe-->
